import { useIntl } from 'react-intl';

import { ANY_SPORT_SERIES_SQUAD_JOIN_CODE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

export const useSquadInviteShare = (code: string) => {
  const { formatMessage } = useIntl();
  const { generateSportContextPath } = useSportContext();

  // oxlint-disable-next-line sorare/no-window-location
  const url = `${window.location.origin}${generateSportContextPath(
    ANY_SPORT_SERIES_SQUAD_JOIN_CODE,
    { params: { code } }
  )}`;

  return {
    url,
    message: formatMessage({ defaultMessage: 'Join my Squad on Sorare!' }),
  };
};
